import { Component, ErrorInfo, ReactNode } from 'react'

import CrashScreen from '@/components/AlertScreen/CrashScreen'
import AppAccessScreen from '@/components/AlertScreen/AppAccessScreen'

import { AppAccessError } from '@/contexts/AuthContext'

import { clearStorage } from '@/services/browserStorage'

type ErrorType = 'none' | 'appAccess' | 'error'

interface ErrorBoundaryProps {
  children: ReactNode
}

interface ErrorBoundaryState {
  errorType: ErrorType
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props)

    // Define a state variable to track whether is an error or not
    this.state = { errorType: 'none' }
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    // Update state so the next render will show the fallback UI

    if (error instanceof AppAccessError) {
      clearStorage()
      return { errorType: 'appAccess' }
    }
    return { errorType: 'error' }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    // You can use your own error logging service here
    console.log(error, errorInfo)
  }

  render() {
    // Check if the error is thrown
    switch (this.state.errorType) {
      case 'none':
        // Return children components in case of no error
        return this.props.children

      case 'appAccess':
        return <AppAccessScreen />

      default:
        return <CrashScreen />
    }
  }
}

export default ErrorBoundary
